module.exports = __webpack_public_path__ + "img/costIndex.2f132c29.png";